export default "__VITE_ASSET__CWgi0Xh3__"